import { generatedAnswerAnalyticsClient } from '../../features/generated-answer/generated-answer-analytics-actions.js';
import { buildInteractiveCitationCore, } from '../core/generated-answer/headless-core-interactive-citation.js';
/**
 * Creates an `InteractiveCitation` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `InteractiveCitation` properties.
 * @returns An `InteractiveCitation` controller instance.
 *
 * @group Controllers
 * @category InteractiveCitation
 */
export function buildInteractiveCitation(engine, props) {
    return buildInteractiveCitationCore(engine, generatedAnswerAnalyticsClient, props);
}
